import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="turnstile"
export default class extends Controller {
  connect() {
    this.renderAll()
    document.addEventListener("turbo:load", this.renderAll)
    document.addEventListener("turbo:render", this.renderAll)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.renderAll)
    document.removeEventListener("turbo:render", this.renderAll)
  }

  renderAll = () => {
    // Defer until the Turnstile script is available
    if (typeof window.turnstile === "undefined" || typeof window.turnstile.render !== "function") {
      window.setTimeout(this.renderAll, 50)
      return
    }

    // Find all placeholders on the page and render if not already rendered
    document.querySelectorAll('.cf-turnstile').forEach((element) => {
      if (element.dataset.rendered === 'true') return

      const sitekey = element.dataset.sitekey
      const theme = element.dataset.theme || 'auto'

      if (!sitekey) return

      window.turnstile.render(element, { sitekey, theme })
      element.dataset.rendered = 'true'
    })
  }
}

